export const subtractFixedWidth = () => {
    // fixed width (not effected by viewport resizing: left sidebar width + main-content left-side and right-side paddings
    const sideBar = document.querySelector('.sidebar-drawer') as HTMLElement;
    const mainContent = document.querySelector('.main-content') as HTMLElement;
    const style = getComputedStyle(mainContent);
    const mainContentPadding = 2 * parseInt(style.padding);

    return sideBar.clientWidth + mainContentPadding;
};